import { CiDark, CiLight } from "react-icons/ci";
import { ImProfile } from "react-icons/im";
import { MdLogout } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { logOut } from "../store/reducer/auth";
import { setTheme } from "../store/reducer/theme";
import { API_URL_FILE, FRONT_URL, IMG_USER_URL } from "../Utils/constants";

const Header = () => {
  const img_url_default = "./dist/";
  const user = useSelector((state) => state.auth);
  const theme = useSelector((state) => state.theme);
  const messages = useSelector((state) => state.message);
  // console.log(messages);
  const messagesNonLus = messages.filter((message) => message.readAt === null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = (e) => {
    e.preventDefault();

    dispatch(logOut());

    navigate("/login");
  };

  const handleChangeTheme = (e) => {
    e.preventDefault();

    const newTheme = theme === "light" ? "dark" : "light";
    newTheme === "light"
      ? document.body.classList.remove("dark-mode")
      : document.body.classList.add("dark-mode");

    localStorage.setItem("theme", newTheme);
    dispatch(setTheme(newTheme));
  };

  return (
    <>
      {/* Navbar */}
      {/* <nav className="main-header navbar navbar-expand navbar-dark"> */}
      <nav
        className={`main-header navbar navbar-expand  ${
          theme === "light" ? "navbar-light" : "navbar-dark"
        } `}
      >
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" role="button">
              <i className="fas fa-bars" />
            </a>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <a href={FRONT_URL} target="_blank" className="btn btn-primary">
              <b>Aller sur le site</b>
            </a>
          </li>
          {/* <li className="nav-item d-none d-sm-inline-block">
            <a href="#" className="nav-link">
              Contact
            </a>
          </li> */}
        </ul>
        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          {/* Navbar Search */}
          {/* <li className="nav-item">
            <a className="nav-link" data-widget="navbar-search" role="button">
              <i className="fas fa-search" />
            </a>
            <div className="navbar-search-block">
              <form className="form-inline">
                <div className="input-group input-group-sm">
                  <input
                    className="form-control form-control-navbar"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                  />
                  <div className="input-group-append">
                    <button className="btn btn-navbar" type="submit">
                      <i className="fas fa-search" />
                    </button>
                    <button
                      className="btn btn-navbar"
                      type="button"
                      data-widget="navbar-search"
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </li> */}

          {/* Messages Dropdown Menu */}
          <li className="nav-item dropdown">
            <NavLink to="/messages" className="nav-link">
              <div>
                <i className="far fa-comments" />
                {messagesNonLus.length > 0 && (
                  <span className="badge badge-danger navbar-badge">
                    {messagesNonLus.length}
                  </span>
                )}
              </div>
            </NavLink>
          </li>
          <li
            className="nav-item dropdown"
            style={{ cursor: "pointer" }}
            onClick={handleChangeTheme}
          >
            <div className="nav-link">
              <div>
                {theme === "light" ? (
                  <CiDark size={25} />
                ) : (
                  <CiLight size={25} />
                )}
              </div>
            </div>
          </li>

          <li className="nav-item dropdown">
            <a className="nav-link" data-toggle="dropdown">
              <div className="user-panel d-flex">
                <div className="image" style={{ cursor: "pointer" }}>
                  <img
                    style={{ height: "2.1rem" }}
                    src={
                      user?.img &&
                      ((user?.img.split("/")).length > 1
                        ? img_url_default
                        : API_URL_FILE + "/" + IMG_USER_URL) + user?.img
                    }
                    className="img-circle elevation-6"
                    alt={
                      user.firstname?.split(" ")[0] +
                      " " +
                      user.lastname?.toUpperCase()
                    }
                  />
                </div>
              </div>
            </a>
            <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
              <ul className="list-group">
                <li className="list-group-item">
                  <div className="card" style={{ boxShadow: "none" }}>
                    <div className="card-body">
                      <div className="d-flex flex-column align-items-center">
                        <div>
                          <img
                            src={
                              user?.img &&
                              ((user?.img.split("/")).length > 1
                                ? img_url_default
                                : API_URL_FILE + "/" + IMG_USER_URL) + user?.img
                            }
                            className="img-circle elevation-4"
                            alt={
                              user.firstname?.split(" ")[0] +
                              " " +
                              user.lastname?.toUpperCase()
                            }
                            width={120}
                            height={120}
                          />
                        </div>
                        <div className="mt-4">
                          <h5 className="card-title">
                            {user.firstname
                              ?.split(" ")[0]
                              .charAt(0)
                              .toUpperCase() +
                              user.firstname?.split(" ")[0].slice(1) +
                              " " +
                              user.lastname?.toUpperCase()}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li className="list-group-item">
                  <div className="d-flex justify-content-between">
                    <button
                      className="btn btn-info"
                      onClick={() => navigate("/profile")}
                    >
                      <ImProfile style={{ fontSize: "20px" }} />
                    </button>
                    <button className="btn btn-info" onClick={logout}>
                      <MdLogout style={{ fontSize: "20px" }} />
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </nav>
      {/* /.navbar */}
    </>
  );
};

export default Header;
